import { extendableComponent } from '@graphcommerce/next-ui/Styles'
import { responsiveVal } from '@graphcommerce/next-ui/Styles/responsiveVal'
import { Box, Link, SxProps, Theme, Typography, Button } from '@mui/material'
import React from 'react'

export type BlogListItemProps = {
  asset: React.ReactNode
  url: string
  title: string
  sx?: SxProps<Theme>
  first?: boolean
}

const name = 'BlogListItem' as const
const parts = ['item', 'date', 'asset', 'title'] as const
const { classes } = extendableComponent(name, parts)

export function BlogListItem(props: BlogListItemProps) {
  const { asset, url, title, first, sx = [] } = props

  return (
    <Box
      className={`${classes.item} ${first ? 'BlogMainItem' : ''}`}
      sx={[
        (theme) => ({
          display: 'grid',
          gridTemplateRows: `${responsiveVal(140, 250)} 1fr`,
          alignContent: 'start',
          color: theme.palette.text.primary,
          marginBottom: 0,
          borderRadius: '10px',
          overflow: 'hidden',
          height: '100%',

          '&:hover, &:focus, &:active': {
            boxShadow: 3,
          },

          '& > .MuiLink-root': {
            height: '100%',
            overflow: 'hidden',
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Link href={url} color='inherit' underline='hover'>
        <Box
          className={classes.asset}
          sx={(theme) => ({
            display: 'grid',
            overflow: 'hidden',
            height: '100%',
            width: '100%',
            '& img': {
              height: '100% !important',
              objectFit: 'cover',
            },
            '& p': {
              alignSelf: 'center',
              justifySelf: 'center',
            },
            backgroundColor: theme.palette.background.paper,
          })}
        >
          {asset}
        </Box>
      </Link>

      <Box
        sx={(theme) => ({
          p: theme.spacings.xs,
          backgroundColor: theme.palette.primary.contrastText,
          ...(first && {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }),
        })}
      >
        <Link href={url} className={classes.title} color='inherit' underline='none'>
          <Typography
            component='h2'
            variant='h1'
            sx={{
              pr: { xs: 0 },
              overflow: 'hidden',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 3,
            }}
          >
            {title}
          </Typography>
        </Link>
        {first && (
          <Button
            variant='cutRight'
            size='small'
            color='primary'
            href={`/${url}`}
            sx={(theme) => ({
              maxWidth: '155px',
              justifySelf: 'flex-end',
              [theme.breakpoints.down('sm')]: {
                whiteSpace: 'nowrap',
                maxWidth: 'none',
              },
            })}
          >
            Lees verder
          </Button>
        )}
      </Box>
    </Box>
  )
}
